import { useEffect, useRef, useState } from "react";

export default function MouseGlow() {
  const glowRef = useRef(null);
  const dotRef = useRef(null);
  const [hoverInteractive, setHoverInteractive] = useState(false);

  useEffect(() => {
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let gx = x;
    let gy = y;
    let raf;

    const handle = (e) => {
      x = e.clientX;
      y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${x - 6}px, ${y - 6}px, 0)`;
      }
      const t = e.target;
      const interactive =
        t &&
        (t.tagName === "A" ||
          t.tagName === "BUTTON" ||
          t.closest?.("a, button, [role='button'], [data-magnetic]"));
      setHoverInteractive(!!interactive);
    };

    const tick = () => {
      gx += (x - gx) * 0.12;
      gy += (y - gy) * 0.12;
      if (glowRef.current) {
        glowRef.current.style.background = `radial-gradient(420px circle at ${gx}px ${gy}px, rgba(253,24,67,0.16), transparent 60%)`;
      }
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", handle);
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("mousemove", handle);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div
        ref={glowRef}
        className="pointer-events-none fixed inset-0 z-[60] hidden md:block"
        aria-hidden
      />
      <div
        ref={dotRef}
        className="pointer-events-none fixed top-0 left-0 z-[61] hidden md:block transition-[width,height,border-color,background] duration-200 ease-out"
        style={{
          width: hoverInteractive ? 36 : 12,
          height: hoverInteractive ? 36 : 12,
          marginLeft: hoverInteractive ? -18 : -6,
          marginTop: hoverInteractive ? -18 : -6,
          borderRadius: 999,
          border: hoverInteractive
            ? "1px solid rgba(253,24,67,0.9)"
            : "1px solid rgba(255,255,255,0.65)",
          background: hoverInteractive ? "rgba(253,24,67,0.12)" : "transparent",
          mixBlendMode: "difference",
        }}
        aria-hidden
      />
    </>
  );
}
